let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kaqlg")).then(() => parcelRequire('7Vx4o'));